import { LastMessageText } from '@halo/ui-chat-react';
import type { Msg } from '@halo/chat-sdk-react';
import { Box } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import { MsgStickerPreviewContent } from './msg-sticker-preview-content';

export interface MsgStickerPreviewProps {
  message: Msg;
}

export const MsgStickerPreview = memo(function MsgStickerPreview({
  message,
}: MsgStickerPreviewProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgStickerPreviewContent />
      </Box>
    </LastMessageText>
  );
});
